import * as _ from 'lodash';
import {personRefreshAttributesAction, personResetAction, personSetSingleChoiceModeAction, personSetTemplateIdAction, personVisibleChangedAction} from 'module/Person/action/PersonAction';
import {templateModel} from 'module/selpan/impl/person/model/PersonUtil';
import {combineReducers} from "redux";
import {createReducer} from 'util/redux';
import {Person} from 'generated/JavaTOmodifications';

const byId = createReducer<{ [persNr in number]?: Person }>({}, builder => builder
	.addCase(personResetAction, (state, {payload}) => {
		const newState = _.keyBy(payload, 'persNr');
		if (_.isEqual(newState, state)) return state
		return newState;
	})
	.addCase(personRefreshAttributesAction, (state, {payload}) => ({...state, [payload.persNr]: payload})),
);

const allIds = createReducer<number[]>([], builder => builder
	.addCase(personResetAction, (state, {payload}) => {
		const newState = _.map(payload, 'persNr');
		if (_.isEqual(newState, state)) return state;
		return newState;
	}),
);

const visibleIds = createReducer<number[]>([], builder => builder
	.addCase(personVisibleChangedAction, (state, {payload}) =>
		_.isEqual(payload, state) ? state : payload,
	),
);

const templateId = createReducer<number | string>(0, builder => builder
	.addCase(personSetTemplateIdAction, (state, {payload}) => {
		const s = payload || 0;
		templateModel.set({templateIndex: s});
		return s;
	}),
);

const singleChoiceMode = createReducer<boolean>(true, builder => builder
	.addCase(personSetSingleChoiceModeAction, (state, {payload}) => payload),
);


export const PersonReducerNS = {
	Person: combineReducers({
		byId,
		allIds,
		templateId,
		visibleIds,
		singleChoiceMode,
	}),
};

export type PersonStateType = { Person: ReturnType<typeof PersonReducerNS.Person> }